<template>
  <div class="asc-validation-error--container">
    <div>
      <div class="icon">
        <v-icon size="16" :color="getErrorColor">mdi-alert</v-icon>
        <asc-label
          class="text"
          size="sm"
          :value="value"
          :color="getErrorColor"
        ></asc-label>
      </div>
    </div>
    <template v-if="buttonsEnabled">
      <div class="retry">
        <v-btn v-if="retryEnabled" icon @click="handleRetryUpload">
          <v-icon size="16">mdi-refresh</v-icon>
        </v-btn>
        <v-btn icon @click="handleCancelFile">
          <v-icon size="16">mdi-close-circle</v-icon>
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import AscLabel from './AscLabel'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscValidationError',

  components: {
    AscLabel,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    file: {
      type: [Object, File],
      default: null,
    },
    retryEnabled: {
      type: Boolean,
      default: true,
    },
    buttonsEnabled: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    getErrorColor() {
      return variables.warningbase
    },
  },

  methods: {
    handleCancelFile() {
      this.$emit('cancelFileUpload', this.file)
    },
    handleRetryUpload() {
      this.$emit('handleRetryUpload', this.file)
    },
  },
}
</script>

<style lang="scss">
.asc-validation-error--container {
  display: flex;
  margin-top: 4px;
  justify-content: space-between;
  align-items: baseline;

  & .text {
    padding-left: 4px;
  }

  .retry .v-btn--icon {
    width: 18px;
    height: auto;

    &.mdi-refresh {
      transform: scale(-1, 1);
    }
  }
}
</style>
